import { render, staticRenderFns } from "./sales-reports.vue?vue&type=template&id=01043242"
import script from "./sales-reports.vue?vue&type=script&lang=js"
export * from "./sales-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports